<template>

    <div class="app-switcher">
        <a href="#" @click.prevent="opened = !opened">{{ currentConfig.name }}<i class="img icon-triangle-white-8"></i></a>
        <div class="droplist" v-if="opened">
            <span class="title">Selecteer een applicatie</span>
            <span class="active">{{ currentConfig.name }}</span>
            <a href="#" @click.prevent="switchApp(app)" v-for="app in appConfigs">{{ app.name }}</a>
            <div class="logout">
                <a href="#" @click.prevent="logout">Uitloggen</a>
            </div>
        </div>
    </div>

</template>

<script>

    import di from 'di'

    import Component from 'vue-class-component'
    import Vue from 'global-vue'

    import find from 'lodash/find'

    @Component({

        name: 'app-switcher',
        props: ['current']
    })
    export default class extends Vue {

        data() {

            return {
                opened: false
            };
        }

        close(){

            this.opened = false;
        }

        get currentConfig(){

            return find(di.get('config').apps, { id: this.current });
        }

        get appConfigs(){

            return di.get('config').apps.filter(app => app.id !== this.current);
        }

        switchApp(app){

            di.get('appSwitcher').navigate(app.id);
        }

        logout(){

            this.$auth.logout();
        }
    }

</script>